import React, {useEffect, useState} from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import {Box, Typography, useTheme} from "@mui/material";
import {YMaps, Map, SearchControl, Placemark} from '@pbe/react-yandex-maps';

import {tokens} from "../../theme";

const YaMap = ({center, coords, handleChangeCoords}) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [loading, setLoading] = useState(true);

    const [clickCoords, setClickCoords] = useState(coords ? coords : [])
    const handleClickCoords = (ymaps, coords) => {
        // const coords = event.get('coords');
        setClickCoords(coords)
        // ymaps.ready(function () {
        //     ymaps.geocode(coords).then(res => {
        //         const firstGeoObject = res.geoObjects.get(0);
        //         const address = firstGeoObject.getAddressLine();
        //         console.log('Адрес:', address);
        //     });
        // });

        handleChangeCoords(coords)
    }

    return (
        <Box>
            {loading
                ?   <YMaps query={{ apikey: '832b5a4a-c4e9-4c34-ac20-e5bf8d7666e3' }}>
                        <Map
                            defaultState={{ center: center ? center : [55.1, 37.1], zoom: 15 }}
                            instanceRef={ref => {
                                if (ref) {
                                    // Пример: получаем адрес при клике
                                    ref.events.add('click', (e) => {
                                    const coords = e.get('coords');
                                    handleClickCoords(ref.ymaps, coords);
                                    });
                                }
                            }}
                            // onClick={handleClickCoords}
                        >
                            <Placemark geometry={clickCoords} />
                            {/* <SearchControl options={{ float: 'right' }} /> */}
                        </Map>
                    </YMaps>
                : <LinearProgress />
            }
        </Box>
    );
}
export default YaMap;